/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Step1_TitleInputs */

const en_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const de_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysieren`)
};

const fr_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser`)
};

const es_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizar`)
};

const it_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizza`)
};

const nl_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseren`)
};

const pl_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizuj`)
};

const fi_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysoi`)
};

const da_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysér`)
};

const sv_keyword_optimizer_step1_title = /** @type {(inputs: Keyword_Optimizer_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysera`)
};

/**
* | output |
* | --- |
* | "Analyze" |
*
* @param {Keyword_Optimizer_Step1_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_step1_title = /** @type {((inputs?: Keyword_Optimizer_Step1_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Step1_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_step1_title(inputs)
	if (locale === "fr") return fr_keyword_optimizer_step1_title(inputs)
	if (locale === "es") return es_keyword_optimizer_step1_title(inputs)
	if (locale === "it") return it_keyword_optimizer_step1_title(inputs)
	if (locale === "nl") return nl_keyword_optimizer_step1_title(inputs)
	if (locale === "pl") return pl_keyword_optimizer_step1_title(inputs)
	if (locale === "fi") return fi_keyword_optimizer_step1_title(inputs)
	if (locale === "da") return da_keyword_optimizer_step1_title(inputs)
	if (locale === "sv") return sv_keyword_optimizer_step1_title(inputs)
	return en_keyword_optimizer_step1_title(inputs)
});